import { ProviderCreateDialogComponent } from './create-dialog/create-dialog.component';
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTimepickerModule } from '@dhutaryan/ngx-mat-timepicker';
import { DeliveryTimeInputComponent } from './warehouse-delivery/delivery-time-input.component';
import { CommonModule } from '@angular/common';
import { SelectorComponent } from './selector/selector.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ListComponent } from './list/list.component';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { ProfileComponent } from './profile/profile.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProviderWarhouseListComponent } from './provider-warehouse-list/list.component';
import { ProviderWarehouseCreateComponent } from './provider-warehouse-create/create.component';
import { CityModule } from '../city/city.module';
import { RouterModule } from '@angular/router';
import { UploadSettingsComponent } from './upload-settings/upload-settings.component';
import { WarehouseDeliveryComponent } from './warehouse-delivery/warehouse-delivery.component';

@NgModule({
  declarations: [
    ProviderCreateDialogComponent,
    SelectorComponent,
    ListComponent,
    ProfileComponent,
    ProviderWarhouseListComponent,
    ProviderWarehouseCreateComponent,
    UploadSettingsComponent,
    WarehouseDeliveryComponent,
    DeliveryTimeInputComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatTimepickerModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatTableModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSortModule,
    CityModule,
    RouterModule
  ],
  exports: [SelectorComponent]
})
export class ProviderModule {}
